// extracted by mini-css-extract-plugin
export default {"container":"Patient_container__LoTwF","linkBoxes":"Patient_linkBoxes__j1HTT","linkBox":"Patient_linkBox__ho8T0","boxes":"Patient_boxes__njN7z"};